import ScrollToBottomButton from './ScrollToBottomButton';

export default ScrollToBottomButton;
